export function buildRouteUrl({
  template,
  recruitSessionId = undefined,
  workspaceId = undefined,
  profileId = undefined,
  userId = undefined,
}) {
  let route = template;
  
  // Reemplazar parámetros de ruta
  if (recruitSessionId) route = route.replace(':id', recruitSessionId).replace(':recruitSessionId', recruitSessionId);
  if (profileId) route = route.replace(':profileId', profileId);
  if (userId) route = route.replace(':userId', userId);
  
  // Agregar query params si existen
  const queryParams = [];
  if (workspaceId) queryParams.push(`workspaceId=${workspaceId}`);
  
  return queryParams.length > 0 ? `${route}?${queryParams.join('&')}` : route;
}
